var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.332 3.763 1.723 1.446a.59.59 0 1 1-.76.905L.313 3.61a.588.588 0 0 1-.165-.223.59.59 0 0 1 .134-.744L3.267.138a.59.59 0 0 1 .759.905L2.19 2.581h5.332a.59.59 0 0 1 .174.027 3.149 3.149 0 1 1-1.163 6.076l.27-1.172a1.968 1.968 0 1 0 .862-3.724l.006-.025h-5.34z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.7e8088a975ca50506eb67d6b9fd0eec1.svg";
export { ForwardRef as ReactComponent };